// Cleaned-up and validation-fixed version of editAdminquiz.js

import React, { useState, useEffect, useRef } from "react";
import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
import Sidebar from "../components/dashboard/sidebar";
import SideMenu from "./student/SideMenu";

import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import Select from "react-select";
import Loader from "../components/loader";
import tmdbApi from "../api/tmdbApi";
import SessionPopup from "./SessionPopup";

let { lambda, appname } = window.app;

const EditAdminQuiz = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [editUser, setEditUser] = useState({ diagnosis: "", cost: "", status: "" });
    const [selectedCases, setSelectedCases] = useState([]);
    const [cases, setCases] = useState([]);
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);

    useEffect(() => {
        if (!localStorage.getItem("token")) navigate("/");
        GetCpcCasesInfo();
        if (id) fetchQuizData();
    }, [id]);

    const fetchQuizData = async () => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(`${lambda}/quizInfo?appname=${appname}&quizid=${id}&token=${token}`);
            const result = res.data?.result?.[0];
            if (res.data.result === "Invalid token or Expired") {
                // localStorage.clear();
                // navigate("/");
                setShowSessionPopupup(true)
                return;
            }
            if (result) {
                setEditUser({
                    diagnosis: result.diagnosis || "",
                    cost: result.cost || "",
                    status: result.status || "",
                });
                setSelectedCases(
                    result?.files?.map((file) => ({ value: file.caseid, label: file.diagnosis })) || []
                );
            }
        } catch (err) {
            console.error("Fetch failed", err);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setEditUser((prev) => ({ ...prev, [name]: value }));
    };

    const handleCaseChange = (selectedOptions) => {
        setSelectedCases(selectedOptions);
    };

    const validateForm = () => {
        let valid = true;
        const newErrors = {};

        if (!editUser.diagnosis.trim()) {
            newErrors.diagnosis = "Please enter Title";
            valid = false;
        }

        if (!editUser.cost.trim() || isNaN(editUser.cost)) {
            newErrors.cost = "Please enter valid Cost";
            valid = false;
        }

        if (!editUser.status) {
            newErrors.status = "Please select Status";
            valid = false;
        }

        setErrors(newErrors);
        return valid;
    };

    const GetCpcCasesInfo = async () => {
        try {
            const response = await tmdbApi.cpcCaseInfo();
            if (response?.result) {
                console.log(response?.result,"---")
                setCases(response?.result?.questionData || []);
            }
        } catch {
            console.log("error");
        }
    };

    const handleSubmit = async () => {
        if (!validateForm()) return;
        setLoading(true);

        const token = localStorage.getItem("token");
        const payload = {
            diagnosis: editUser.diagnosis,
            cost: editUser.cost,
            status: editUser.status,
            tags: [], // add tags if needed
            caseid: id,
        };

        try {
            const res = await axios.post(
                `${lambda}/updateQuiz?appname=${appname}&quizid=${id}`,
                payload
            );
            if (res.data?.result === "Invalid token or Expired") {
                // localStorage.clear();
                // navigate("/");
                 setShowSessionPopupup(true)
            } else {
                alert("Updated Successfully");
                navigate("/adminquiz");
            }
        } catch (err) {
            console.error("Update failed", err);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
        {showSessionPopupup && <SessionPopup />} 
        <div id="layout-wrapper">
            <Header />
         <SideMenu />
            <div className="main-content">
                <div className="page-content">
                    <div className="container-fluid">
                        <h4>{id ? "Edit Quiz" : "Add Quiz"}</h4>

                        {loading ? (
                            <Loader />
                        ) : (
                            <div className="form">
                                <div className="mb-3">
                                    <label>Title *</label>
                                    <input
                                        type="text"
                                        name="diagnosis"
                                        value={editUser.diagnosis}
                                        onChange={handleChange}
                                        className="form-control"
                                    />
                                    {errors.diagnosis && <span className="text-danger">{errors.diagnosis}</span>}
                                </div>
                                <div className="mb-12 col-lg-12 col-12 col-md-12">
                                    <label>Select Cases</label>
                                    {cases && (
                                        <Select
                                            isMulti
                                            value={selectedCases}
                                            options={
                                                Array.isArray(cases)
                                                    ? cases
                                                        .filter((item) => item.diagnosis)
                                                        .map((eachItem) => ({
                                                            value: `${eachItem.caseid}`,
                                                            label: eachItem.diagnosis,
                                                        }))
                                                    : []
                                            }
                                            name="cases"
                                            onChange={handleChange}
                                            placeholder="Select"
                                            classNamePrefix="my-select"

                                        />
                                    )}
                                    {errors?.cases && <div className="text-danger">{errors.cases}</div>}
                                </div>

                                <div className="mb-3 col-md-4">
                                    <label>Cost *</label>
                                    <input
                                        type="text"
                                        name="cost"
                                        value={editUser.cost}
                                        onChange={handleChange}
                                        className="form-control"
                                    />
                                    {errors.cost && <span className="text-danger">{errors.cost}</span>}
                                </div>

                                <div className="mb-3 col-md-4">
                                    <label>Status *</label>
                                    <select
                                        name="status"
                                        value={editUser.status}
                                        onChange={handleChange}
                                        className="form-control"
                                    >
                                        <option value="">Select</option>
                                        <option value="ACTIVE">ACTIVE</option>
                                        <option value="INACTIVE">INACTIVE</option>
                                    </select>
                                    {errors.status && <span className="text-danger">{errors.status}</span>}
                                </div>



                                <button onClick={handleSubmit} className="btn btn-primary">
                                    Save
                                </button>
                            </div>
                        )}
                    </div>
                </div>
                <Footer />
            </div>
        </div>
        </>
    );
};

export default EditAdminQuiz;